// WHAT CAN BE CHANGED?
// You can change the colour of the close icon below

<template>
    <div id="filePreviewer">
        <svg-icon
            icon="close"
            fill="#FF6600"
            height="20px"
            width="20px"
            v-on:click="closeFilePreviewer()"
            id="filePreviewer__close-icon"
        />
        <div id="filePreviewer__preview-container">
        </div>
    </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue';

export default {
    name: "FilePreviewer",
    components: {
        SvgIcon
    },
    props: {
        content: {
            type: File,
            required: true
        },
    },
    mounted() {
        let targetLocation = document.getElementById("filePreviewer__preview-container");

        if(this.content.type.match("image/*")) {
            let imageURL = URL.createObjectURL(this.content);
            targetLocation.style.backgroundImage = "url(" + imageURL + ")";
        }
        else if(this.content.type.match("video/*")) {
            let iframeElement = document.createElement("iframe");
            iframeElement.setAttribute("id", "filePreviewer__preview-container__preview-iframe");
            iframeElement.src = URL.createObjectURL(this.content);
            iframeElement.onLoad = function () {
                URL.revokeObjectURL(iframeElement.src);
            };
            targetLocation.append(iframeElement);
        }
        else if(this.content.type.match("audio/*")) {
            let audioElement = document.createElement("audio");
            audioElement.setAttribute("id", "filePreviewer__preview-container__preview-audio");
            audioElement.setAttribute("controls","true");
            audioElement.setAttribute("preload", "auto");
            audioElement.src = URL.createObjectURL(this.content);
            audioElement.onLoad = function () {
                URL.revokeObjectURL(audioElement.src);
            };
            targetLocation.append(audioElement);
        } else {
            alert("Dit type bestand wordt niet ondersteund");
            this.closeFilePreviewer();
        }
    },
    methods: {
        closeFilePreviewer() {
            this.$emit('closePreview')
        }
    }
};
</script>

<style lang="scss">
#filePreviewer {
    position: fixed;
    background-color: black;
    width: 100vw;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 998;
    padding: 50px 0px 80px;
    box-sizing: border-box;

    #filePreviewer__close-icon {
        position: absolute;
        top: 16px;
        right: 16px;
    }

    #filePreviewer__preview-container {
        height: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;

        #filePreviewer__preview-container__preview-iframe {
            width: 100%;
            height: auto;
            border: none;
        }

        #filePreviewer__preview-container__preview-audio {
            margin-top: 35vh;
            filter: sepia(20%) saturate(70%) grayscale(1) contrast(99%) invert(12%);
        }
    }
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
    #filePreviewer {

    }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
    #filePreviewer {

    }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px)  {
    #filePreviewer {

    }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px)  {
    #filePreviewer {

    }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px)  {
    #filePreviewer {
       
    }
}
</style>